// import React from "react";
// import { FaCheckCircle } from "react-icons/fa";
// import { ReactComponent as SunIcon } from "../assets/sun.svg";
// import { ReactComponent as PlusIcon } from "../assets/star.svg";
// import "./Consult.css";

// const Consult = () => {
//     return (
        
//         <section className="consult-container">
//             {/* Left Section */}
           
//             <div className="consult-left">
//                 <h2>
//                     Why Wait, Make <br /> your first step
//                 </h2>
//                 <p className="consult-subtext">
//                     <FaCheckCircle className="check-icon" /> Free One on One Consultation
//                 </p>
//             </div>
           

//             {/* Right Section */}
//             <div className="consult-right">
//                 <div className="consult-icons">
//                     <PlusIcon className="icon plus" />
//                     <SunIcon className="icon sun" />
//                 </div>
//                 <button className="consult-btn">Book Now</button>
//                 <div className="consult-rating">
//                     <p className="rating-score">4.80/5</p>
//                     <p className="rating-text">From 300+ Customer Reviews</p>
//                 </div>
//             </div>
              
//         </section>
        
//     );
// };

// export default Consult;


import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { ReactComponent as SunIcon } from "../assets/sun.svg";
import { ReactComponent as PlusIcon } from "../assets/star.svg";
import "./Consult.css";

import Booking from "../Components-2/Booking";
import ModalWrapper from "../Components-2/ModalWrapper";

const Consult = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="consult-container">
      {/* Left Section */}
      <div className="consult-left">
        <h2>
          Why Wait, Make <br /> your first step
        </h2>
        <p className="consult-subtext">
          <FaCheckCircle className="check-icon" /> Free One on One Consultation
        </p>
      </div>

      {/* Right Section */}
      <div className="consult-right">
        <div className="consult-icons">
          <PlusIcon className="icon plus" />
          <SunIcon className="icon sun" />
        </div>

        {/*  Button to open form */}
        <button className="consult-btn" onClick={() => setOpenModal(true)}>
          Book Now
        </button>

        <div className="consult-rating">
          <p className="rating-score">4.80/5</p>
          <p className="rating-text">From 300+ Customer Reviews</p>
        </div>
      </div>

      {/* Modal with Booking form */}
      <ModalWrapper show={openModal} onClose={() => setOpenModal(false)}>
        <Booking prefilledPurpose="Consultation" />
      </ModalWrapper>
    </section>
  );
};

export default Consult;
